'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { PureComponent } from 'react';
import { COMMENT } from 'conversations-message-history/constants/tileMessageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import TileMessage from '../tile-message/TileMessage';
import { getDeliveryStatus } from 'conversations-message-history/util/getDeliveryStatus';
import CommentMessageBody from './CommentMessageBody';
import { isMessageSoftDeleted } from 'conversations-message-history/common-message-format/operators/isMessageSoftDeleted';
import { jsx as _jsx } from "react/jsx-runtime";
class CommentMessage extends PureComponent {
  render() {
    const {
      message,
      onClickAvatar,
      handleClickToDelete,
      positionDescriptors,
      senderName,
      senders,
      visitorLastReadTimestamp,
      fileAttachments,
      onClickToDeleteComment,
      isHovered
    } = this.props;
    if (isMessageSoftDeleted(message)) {
      return null;
    }
    const timestamp = getTimestamp(message);
    const deliveryStatus = getDeliveryStatus(timestamp, visitorLastReadTimestamp);
    return /*#__PURE__*/_jsx(TileMessage, {
      className: "selenium-test-marker-comment-message",
      use: COMMENT,
      positionDescriptors: positionDescriptors,
      children: /*#__PURE__*/_jsx(CommentMessageBody, {
        deliveryStatus: deliveryStatus,
        message: message,
        onClickAvatar: onClickAvatar,
        handleClickToDelete: handleClickToDelete,
        senderName: senderName,
        senders: senders,
        onClickToDeleteComment: onClickToDeleteComment,
        isHovered: isHovered,
        fileAttachments: fileAttachments
      })
    });
  }
}
CommentMessage.displayName = 'CommentMessage';
CommentMessage.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  handleClickToDelete: PropTypes.func,
  isHovered: PropTypes.bool,
  message: RecordPropType('CommentMessage').isRequired,
  onClickAvatar: PropTypes.func,
  onClickToDeleteComment: PropTypes.func,
  positionDescriptors: PositionDescriptors.isRequired,
  senderName: PropTypes.node,
  senders: SenderMap,
  visitorLastReadTimestamp: PropTypes.number
};
CommentMessage.defaultProps = {
  isHovered: false
};
export default CommentMessage;